<div *ngIf="list?.length" class="btn-group" role="group" aria-label="Basic example">
  <button *ngFor="let item of list" type="button" class="btn btn-animation justify-content-center"
    (click)="selectValue(item)"
    [ngClass]="{'btn-animation': isActiveValue === item.value, 'btn-outline-white': isActiveValue !== item.value}">
    {{item.label | translate}}
  </button>
</div>